import { SpotlightPoster } from "@/components/marketplace/commerce/spotlight-poster"
import type { SpotlightSection } from "@/features/feed/contract"
import { feedMoney } from "@/features/feed/map-product"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"
import { formatMoney } from "@/lib/money"

export const SpotlightFeedSection = ({ section, context }: FeedSectionProps<SpotlightSection>) => {
  const { pill, title, accent, sub, cta, image, price, was, quincena, poster, product } = section.data
  if (!cta) return null

  const lines = poster?.lines ?? (accent ? [title, accent] : product ? [title] : undefined)
  const ctaHref = product ? resolveFeedLink(product.link, context.countryCode) : resolveFeedLink(cta.link, context.countryCode, context.page)

  return (
    <SectionFrame section={section} context={context}>
      <SpotlightPoster
        image={image.url}
        imageAlt={image.alt ?? title}
        imageTall={image.urlTall}
        eyebrow={pill}
        lines={lines}
        title={product ? product.title : (sub ?? title)}
        packshot={product ? { image: product.image.url, alt: product.image.alt ?? product.title } : undefined}
        price={product ? formatMoney(feedMoney(product.price)) : price}
        was={product ? (product.compareAtPrice != null ? formatMoney(feedMoney(product.compareAtPrice)) : undefined) : was}
        quincena={quincena && product ? { ...quincena, amount: formatMoney(feedMoney(product.installmentAmount)) } : quincena}
        rating={product?.rating}
        reviewCount={product?.reviewCount}
        cta={cta.label ?? ""}
        ctaHref={ctaHref}
        priority={context.isLeadSection}
      />
    </SectionFrame>
  )
}
